import Routes from '$provider/constants/Route';
import { redirect, type LoadEvent } from '@sveltejs/kit';

export const ssr = false;

/** @type {import('./$types').LayoutLoad} */
export function load({ url }: LoadEvent): void {
  if (url.pathname === '/') {
    throw redirect(302, Routes.Login);
  }
  return;
}
